module.exports = __webpack_public_path__ + "img/icon-exchange.606bce12.svg";